import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { CompanyPageStepUsersComponent } from './company-page-step-users.component';

@NgModule({
  declarations: [CompanyPageStepUsersComponent],
  imports: [CommonModule, FormsModule, NgSelectModule],
  exports: [CompanyPageStepUsersComponent],
  entryComponents: [CompanyPageStepUsersComponent]
})
export class CompanyPageStepUsersModule { }
